/* import __COLOCATED_TEMPLATE__ from './nickname-birthday-row.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();